module.exports = __webpack_public_path__ + "static/fabric-image-maximize-frame-a00bbeb21b8d32913661d08eda29f9b3.png";